import { DotsNotifications } from "dots-ui/dotsNotifications";
import { toastLocalization } from "../../../data/localizations";
import { useContext } from "react";
import { AvisContext } from "../context/AvisContext";

interface IAvisNotificationHocProps {
  children?: React.ReactNode;
}
export function AvisNotificationHoc(
  props: Readonly<IAvisNotificationHocProps>,
) {
  const { children } = props;
  const { res } = useContext(AvisContext);

  return (
    <DotsNotifications
      position="top-center"
      localization={toastLocalization(res)}
    >
      {children}
    </DotsNotifications>
  );
}
